module.exports = __webpack_public_path__ + "img/arrow-right-arrow-left-regular.cc91ee0d.svg";